<form [formGroup]="restaurantForm" class="mb-20">

    <div class="row">
        <div class="col-lg-4">
            <fieldset>
                <legend>Restaurant Details</legend>
                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Restaurant Name</label>
                        <input type="text" formControlName="name" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.name}" maxlength="50">
                        <div *ngIf="fc.name.errors" class="invalid-feedback">
                            <div *ngIf="fc.name.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Owner Name</label>
                        <input type="text" formControlName="ownerName" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.ownerName}" maxlength="50">
                        <div *ngIf="fc.ownerName.errors" class="invalid-feedback">
                            <div *ngIf="fc.ownerName.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Email</label>
                        <input type="text" formControlName="email" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.email}" maxlength="50">
                        <div *ngIf="fc.email.errors" class="invalid-feedback">
                            <div *ngIf="fc.email.errors.required">
                                Required
                            </div>
                            <div *ngIf="fc.email.errors.email">
                                Invalid Email
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group" *ngIf="id === 0 || restaurant">
                    <div class="text-box-wrap">
                        <label>*Restaurant Contact No</label>
                        <input [appPhoneNumberFormatter]="this.restaurantForm.get('mobile').value" type="text"
                            formControlName="mobile" class="form-control" [ngClass]="{'is-invalid': formErrors.mobile}"
                            maxlength="14">
                        <div *ngIf="fc.mobile.errors" class="invalid-feedback">
                            <div *ngIf="fc.mobile.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group">
                    <div class="text-box-wrap">
                        <label>Owner Contact No</label>
                        <input numberOnly type="text" formControlName="mobile2" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.mobile2}" maxlength="10">
                        <div *ngIf="fc.mobile2.errors" class="invalid-feedback">
                            <div *ngIf="fc.mobile2.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>Description</label>
                        <textarea formControlName="description" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.description}" maxlength="1000"></textarea>
                        <div *ngIf="fc.description.errors" class="invalid-feedback">
                            <div *ngIf="fc.description.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>Color Code</label>&nbsp;&nbsp;
                        <p-colorPicker formControlName="colorCode" (onChange)="changeColorCode($event)"></p-colorPicker>
                        <input type="text" formControlName="colorCode" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.colorCode}" maxlength="10">
                        <!-- {{restaurantForm.controls['colorCode'].value}} -->
                        <div *ngIf="fc.colorCode.errors" class="invalid-feedback">
                            <div *ngIf="fc.colorCode.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Login username for restaurant</label>
                        <p-chips name="mobileList" formControlName="mobileList" separator=","></p-chips>
                        <span style="color: green; font-size: small;"> Note: Put comma after the mobile no</span>
                    </div>
                </div> -->

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Login username for Restaurant</label>&nbsp; <a (click)="addNewOption()"><i
                                class="fa fa-plus green" aria-hidden="true"></i></a>
                        <div class="label-none" formArrayName="mobileList"
                            *ngFor="let item of restaurantForm.get('mobileList')['controls']; let i = index;">
                            <div class="flex-ctrl" [formGroupName]="i">
                                <div class="row">
                                    <div class="form-group col-5">
                                        <div class="text-box-wrap">
                                            <input type="text" formControlName="name" class="form-control" name="name"
                                                placeholder="Name"
                                                [ngClass]="{'is-invalid': mobileListFormArray.controls[i].get('name').errors}"
                                                maxlength="100">
                                            <div class="invalid-feedback"
                                                *ngIf="mobileListFormArray.controls[i].get('name').errors?.required">

                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-5">
                                        <div class="text-box-wrap">
                                            <input type="text" formControlName="mobile" class="form-control" numberOnly
                                                placeholder="Mobile"
                                                [ngClass]="{'is-invalid': mobileListFormArray.controls[i].get('mobile').errors}"
                                                maxlength="10">
                                            <div class="invalid-feedback"
                                                *ngIf="mobileListFormArray.controls[i].get('mobile').errors?.required">

                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-2">
                                        <a href="javascript:void(0)" (click)="removeOption(i)"><i
                                                class="fa fa-trash red fa-lg" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div class="col-lg-4">
            <fieldset>
                <legend>Address Details </legend>
                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Country</label>
                        <select (change)="getStates()" [ngClass]="{'is-invalid': formErrors.countryId}"
                            class="form-control" formControlName="countryId">
                            <option [ngValue]="null">Select</option>
                            <option *ngIf="!isProd" [value]="country.India">India</option>
                            <option [value]="country.Usa">USA</option>
                        </select>
                        <div *ngIf="fc.countryId.errors" class="invalid-feedback">
                            <div *ngIf="fc.countryId.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*State</label>
                        <select (change)="getCities()" [ngClass]="{'is-invalid': formErrors.stateId}"
                            class="form-control" formControlName="stateId">
                            <option [ngValue]="null">Select</option>
                            <option *ngFor="let item of stateList" [value]="item.key">{{item?.value}}</option>
                        </select>
                        <div *ngIf="fc.stateId.errors" class="invalid-feedback">
                            <div *ngIf="fc.stateId.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*City</label>
                        <select [ngClass]="{'is-invalid': formErrors.cityId}" class="form-control"
                            formControlName="cityId">
                            <option [ngValue]="null">Select</option>
                            <option *ngFor="let item of cityList" [value]="item.key">{{item?.value}}</option>
                        </select>
                        <div *ngIf="fc.cityId.errors" class="invalid-feedback">
                            <div *ngIf="fc.cityId.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Zip Code</label>
                        <input numberOnly type="text" formControlName="zipCode" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.zipCode}" maxlength="6">
                        <div *ngIf="fc.zipCode.errors" class="invalid-feedback">
                            <div *ngIf="fc.zipCode.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Address</label>
                        <textarea formControlName="address" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.address}" maxlength="50"></textarea>
                        <div *ngIf="fc.address.errors" class="invalid-feedback">
                            <div *ngIf="fc.address.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group">
                    <div class="text-box-wrap">
                        <label>Map Location</label>
                        <input type="text" formControlName="mapLocation" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.mapLocation}" maxlength="50">
                        <div *ngIf="fc.mapLocation.errors" class="invalid-feedback">
                            <div *ngIf="fc.mapLocation.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div> -->
                <ic-google-address *ngIf="address" [googleAddress]="address"
                    (googleAddressEvent)="googleAddressEvent($event)">
                </ic-google-address>

            </fieldset>
        </div>
        <div class="col-lg-4">
            <fieldset>
                <legend>Other Info </legend>
                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Time Zone</label>
                        <select [ngClass]="{'is-invalid': formErrors.timeZoneId}" class="form-control"
                            formControlName="timeZoneId">
                            <option [ngValue]="null">Select</option>
                            <option *ngFor="let item of timeZoneList" [value]="item.key">{{item?.value}}</option>
                        </select>
                        <div *ngIf="fc.timeZoneId.errors" class="invalid-feedback">
                            <div *ngIf="fc.timeZoneId.errors.required">
                                Required
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>Facebook Page Url</label>
                        <input type="text" formControlName="facebookLink" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.facebookLink}" maxlength="100">
                        <div *ngIf="fc.facebookLink.errors" class="invalid-feedback">
                            <div *ngIf="fc.facebookLink.errors.required">
                                Required
                            </div>
                            <!-- <div *ngIf="fc.facebookLink.errors.pattern">
                                Invalid Url
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>Android App Url</label>
                        <input type="text" formControlName="androidAppLink" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.androidAppLink}" maxlength="100">
                        <div *ngIf="fc.androidAppLink.errors" class="invalid-feedback">
                            <div *ngIf="fc.androidAppLink.errors.required">
                                Required
                            </div>
                            <!-- <div *ngIf="fc.androidAppLink.errors.pattern">
                                Invalid Url
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>IOS App Url</label>
                        <input type="text" formControlName="iosAppLink" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.iosAppLink}" maxlength="100">
                        <div *ngIf="fc.iosAppLink.errors" class="invalid-feedback">
                            <div *ngIf="fc.iosAppLink.errors.required">
                                Required
                            </div>
                            <!-- <div *ngIf="fc.iosAppLink.errors.pattern">
                                Invalid Url
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>Table Order Url</label>
                        <input type="text" formControlName="tableOrderLink" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.tableOrderLink}" maxlength="100">
                        <div *ngIf="fc.tableOrderLink.errors" class="invalid-feedback">
                            <div *ngIf="fc.tableOrderLink.errors.required">
                                Required
                            </div>
                            <!-- <div *ngIf="fc.tableOrderLink.errors.pattern">
                                Invalid Url
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="text-box-wrap">
                        <label>*Online Order Url</label>
                        <input type="text" formControlName="webSiteLink" class="form-control"
                            [ngClass]="{'is-invalid': formErrors.webSiteLink}" maxlength="100">
                        <div *ngIf="fc.webSiteLink.errors" class="invalid-feedback">
                            <div *ngIf="fc.webSiteLink.errors.required">
                                Required
                            </div>
                            <!-- <div *ngIf="fc.webSiteLink.errors.pattern">
                                Invalid Url
                            </div> -->
                        </div>
                    </div>
                    <br />
                    <button *ngIf="id > 0" [disabled]="restaurantForm.get('webSiteLink').value ==''"
                        (click)="bindDomain()" type="button" class="btn btn-secondary">Bind
                        Domain</button>
                </div>
            </fieldset>
        </div>
    </div>

    <div class="shadow-box">
        <div class="flex-row-box">
            <label>Ask User Location</label>
            <p-inputSwitch formControlName="userCurrentLocation">
            </p-inputSwitch>
        </div>
        <div class="flex-row-box">
            <label>Show Map</label>
            <p-inputSwitch formControlName="showMap">
            </p-inputSwitch>
        </div>
        <div class="flex-row-box">
            <label>Show Facebook Icon</label>
            <p-inputSwitch formControlName="showFacebook" (onChange)="validateControls()">
            </p-inputSwitch>
        </div>
        <div class="flex-row-box">
            <label>Show Android Icon</label>
            <p-inputSwitch formControlName="showAndroidStore" (onChange)="validateControls()">
            </p-inputSwitch>
        </div>
        <div class="flex-row-box">
            <label>Show IOS Icon</label>
            <p-inputSwitch formControlName="showIosStore" (onChange)="validateControls()">
            </p-inputSwitch>
        </div>
        <div class="flex-row-box">
            <label>Accept Android Orders</label>
            <p-inputSwitch formControlName="isAndroidOrder">
            </p-inputSwitch>
        </div>
        <div class="flex-row-box">
            <label>Accept IOS Orders</label>
            <p-inputSwitch formControlName="isIosOrder">
            </p-inputSwitch>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <label>Choose Logo (Recommended size is 160 x 160)</label>&nbsp;
            <a *ngIf="restaurant" (click)="removeLogo()" href="javascript:void(0)"><i class="fa fa-trash red fa-lg" aria-hidden="true"></i></a>
            <div class="form-control" style="height: auto;">
                <input type="file" (change)="fileChangeEventLogo($event)" />
                <div *ngIf="restaurant && !imageChangedEventLogo">
                    <br />
                    <img [src]="restaurant?.logo" style="max-height: 200px; max-width:200px;" />
                </div>
                <div class="row" style="margin-top: 15px;" [hidden]="!imageChangedEventLogo">
                    <div class="text-center col-md-8">
                        <h5>Crop Image</h5>
                        <image-cropper [imageChangedEvent]="imageChangedEventLogo" [maintainAspectRatio]="false"
                            style="max-height: 200px; max-width:200px;" [aspectRatio]="4 / 4" format="png"
                            (imageCropped)="imageCroppedLogo($event)" (imageLoaded)="imageLoaded()"
                            (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailedLogo()">
                        </image-cropper>
                    </div>
                    <div class="text-center col-md-4">
                        <h5>Preview</h5>
                        <img [src]="croppedImageLogo" />
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6">
            <label>Choose Background (Recommended size is 1300 x 800)</label>&nbsp;
            <a *ngIf="restaurant" (click)="removeBackground()" href="javascript:void(0)"><i class="fa fa-trash red fa-lg" aria-hidden="true"></i></a>
            <div class="form-control" style="height: auto;">
                <input type="file" (change)="fileChangeEventBackground($event)" />
                <div class="row" style="margin-top: 15px;"
                    [hidden]="!croppedImageBackground && !restaurant?.backgroundImage">
                    <div class="text-center col-md-4">
                        <h5>Preview</h5>
                        <img [src]="croppedImageBackground || restaurant?.backgroundImage"
                            style="max-height: 200px; max-width:200px;" />
                    </div>
                </div>
            </div>
        </div>
    </div>


</form>

<div class="modal-footer">
    <button *ngIf="!profile" (click)="onPrevious()" type="button" class="btn btn-secondary">Cancel</button>
    <button type="button" (click)="onSave()" [disabled]="!restaurantForm.valid" class="btn btn-success">Save</button>
</div>